import {
    observable,
    action,
    //computed
} from "mobx";
import { createBrowserHistory } from "history";
import { getQueryVariable, prop } from "@/utils/utils";
class HistoryStore {
  @observable history = createBrowserHistory();
  @observable historyParams = prop(location, "pathname");
  /**
   * '/'
   * '/subscribe'
   * '/privacy-policy'
   * '/term-of-use'
   * '/terms-of-service'
   * '/feedback'
   *
   * @param {*} params can be set with '', '/site'
   *                      {'pathname':'/xxx','search':''}
   * @memberof HistoryStore
   */
  @action push(params) {
      this.history.push(params);
      this.historyParams = params;
  }
  @action goToHomePage() {
    const vTest = getQueryVariable("test");

    if (vTest === 'performance') {
        this.history.push("/?test=performance");
        this.historyParams = "/?test=performance";
    } else {
        this.history.push("/");
        this.historyParams = "/";
    }
  }
}

export default HistoryStore;
